import { useEffect, useRef } from 'preact/hooks';

function useEventListener(callback, eventToListen) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  function onEventResponse(event) {
    const eventData = event.detail.eventData;

    if (event.type !== eventToListen) {
      return;
    }

    callbackRef.current(eventData);
  }

  useEffect(() => {
    document.addEventListener(eventToListen, onEventResponse);

    return () => {
      document.removeEventListener(eventToListen, onEventResponse);
    };
  }, [eventToListen]);
}
export default useEventListener;
